function JobDataFactory(showType, jobData) {
    this.jobData = jobData;
    this.showType = showType;
    var self = this;
    _initJobList = function () {
        var _jobs = [];
        for (var index in self.jobData) {
            var _job = {};
            _job.title = self.jobData[index].Title;
            if (self.jobData[index].Categories.length > 0) {
                _job.category = self.jobData[index].Categories[0]
            }
            _job.Id = self.jobData[index].Id;
            _job.location = self.jobData[index].Location;
            _job.deadline = self.jobData[index].ApplicationDeadline;
            _job.enddate =formatDate(self.jobData[index].EndDate);
            _job.countryId = self.jobData[index].CountryId;
            _job.href = self.jobData[index].JobListItemUrl + "?JobId=" + _job.Id;
            _job.newpage = self.jobData[index].OpenInNewPage;
            _jobs.push(_job);
        }
        return _jobs;
    }
    this.initJobs = function () {
        if ("joblist" == this.showType) {
           return _initJobList();
        } else if ("jobTeaser" == showType) {
            return _initJobList();
        }
    }
}

function formatDate(date) {
    var dateArray = date.split("T")[0].split('-');
    var monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var month =parseInt(dateArray[1]);
    var monthEng;
    for (var i = 1; i <= monthArray.length; i++){
        if (month == i) {
            monthEng = monthArray[i-1];
            break;
        }
    }
    return "Deadline: "+ dateArray[2] + " " + monthEng + " " + dateArray[0];
}


function DoLayOutFactory(showType, viewModel, fetchItemCount) {
    var self = this;
    self._showType = showType;
    _jobTeaserLayout = function () {
        var filters = viewModel.filters;
        var showMore = viewModel.showMore;
        var header = viewModel.Header;
        var showMoreText = viewModel.showMoreText;
        var jobs = _handleLayoutModel(viewModel.jobs,fetchItemCount);
        var obj = {};
        obj.filters = filters;
        obj.showMore = showMore;
        obj.header = header;
        obj.showMoreText = showMoreText;
        obj.jobs = jobs;
        return obj;
    }
    _jobListLayout = function () {
        return viewModel;
    }
    self.DoLayout = function () {
        if ("joblist" == self._showType) {
            return _jobListLayout();
        }
        else if ("jobTeaser" == self._showType) {
            return _jobTeaserLayout();
        }
    }
}
function _fetchRowData(array, page_size, page_number) {
    --page_number; 
    return array.slice(page_number * page_size, (page_number + 1) * page_size);
}
function _handleLayoutModel(jobs, fetchItemCount) {
    var rows = [];
    var countPreRow=3;
    var jobCount = jobs.length;
    var rowCount = Math.ceil(jobCount / countPreRow);
    var tempData = [];
    console.log("rowCount:", rowCount);
   
    for (var i = 1; i <= rowCount; i++) {
        tempData.push(_fetchRowData(jobs, 3, i));
    }
    for(var i in tempData){
        var row=[];
        for (var j in tempData[i]){
            row.push(tempData[i][j]);
        }
        rows.push(row);
    }
    console.log("rows:", rows);
    return rows;
}
function isClearCache(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return "?clearcache=" + unescape(r[2]);
    } else {
        return null;
    }
}
(function () {
    window.js = window.js || {};
    var viewModel = {};
    viewModel.filters = {};
    viewModel.jobs = [];
    var fullJobs;
    var selectedCountries;
    var selectedJobTypes;
    var _fetchItemCount ;
    var pageIndex = 1;
    var _showMoreText;
    var _header;
    var _domElm, _template, _filterTemplate, _showType, _noJobDes, _NoJobLink, _allCountries, _noJobLinkDes;
 
    function _isInselectedJobName(selectedtypes, jobCategoryText) {
        for (var index in selectedtypes) {
            if (selectedtypes[index] == jobCategoryText) {
                return true;
            }
        }
        //
        var jobTypeFilterFromCookieArray = utils.cookie.get("jobTypeFilter").split(',');
        for (var index in jobTypeFilterFromCookieArray) {
            if (jobTypeFilterFromCookieArray[index] == jobCategoryText) {
                return true;
            }
        }
        //
        return false;
    }
    function _isInselectedCountry(selectedtypes,countryId) {
        for (var index in selectedtypes) {
            if (selectedtypes[index] == countryId) {
                return true;
            }
        }
        //
        var jobCountriesFromCookieArray = utils.cookie.get("jobCountriesFilter").split(',');
        for (var index in jobCountriesFromCookieArray) {
            if (jobCountriesFromCookieArray[index] == countryId) {
                return true;
            }
        }
        //
        return false;
    }
  
   
    function initJobTypes(jobTypes) {
        var JobTypes = [];
        for(var index in jobTypes){
            var jobType = {}
            jobType.text = jobTypes[index];
            jobType.index = index + 1;
            jobType.checked = false;
            JobTypes.push(jobType);
        }
        return JobTypes;
    }
    function initCountries(countriesfromserver) {
        var countries = [];
        for (var index in countriesfromserver) {
            var country = {};
            country.id = countriesfromserver[index].Id;
            country.controlId = index + 1;
            country.number = countriesfromserver[index].Number;
            country.text = countriesfromserver[index].Country;
            country.checked = false;
            countries.push(country);
        }
        return countries;
    }
  
    function render(viewmodel) {
        var layOutFactory = new DoLayOutFactory(_showType, viewmodel, _fetchItemCount);
        var handledLayoutViewModel = layOutFactory.DoLayout();
        var renderer = Hogan.compile(_template);
        var filtersPartial = Hogan.compile(_filterTemplate);
        _domElm.innerHTML = renderer.render(handledLayoutViewModel, { filters: filtersPartial });
        setTimeout(fadeIn, 80);
    }
    function fadeIn() {
        var element = document.querySelector(".teaser-deck__spot--hidden");
        if (element) {
            element.classList.remove("teaser-deck__spot--hidden");
            setTimeout(fadeIn, 80);
        }
    }
    function fetchData(postdata, isfromfilter) {
        var jobsPromise = fetch(postdata.JsonUrl, {
            method: "POST",
            body: JSON.stringify(postdata),
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
        });

        Promise.all([jobsPromise]).then(function (results) {
            Promise.all([
                results[0].json(),
            ]).then(function (results) {
                var jobsfromnet = results[0].Jobs;
                var countriesfromnet = results[0].Countries;
                var jobtypesfromnet = results[0].JobTypes;
                var jobDataFactory = new JobDataFactory(_showType, jobsfromnet);
                var _jobs= jobDataFactory.initJobs();



                var _countries = initCountries(countriesfromnet);
                var _jobTypes = initJobTypes(jobtypesfromnet);

                if (isfromfilter) {
                    viewModel.jobs = [];
                }

                for (var index in _jobs) {
                    viewModel.jobs.push(_jobs[index]);
                }
              
                viewModel.filters.Countries = _countries;
                viewModel.filters.JobTypes = _jobTypes;
                viewModel.filters.showFiltersText = "show filters";
                //set status to checkbox
                for (var index in viewModel.filters.JobTypes) {
                    if (_isInselectedJobName(selectedJobTypes, viewModel.filters.JobTypes[index].text)) {
                        viewModel.filters.JobTypes[index].checked = true;
                    } else {
                        viewModel.filters.JobTypes[index].checked = false;
                    }
                }
                for (var index in viewModel.filters.Countries) {
                    if (_isInselectedCountry(selectedCountries, viewModel.filters.Countries[index].id)) {
                        viewModel.filters.Countries[index].checked = true;
                    } else {
                        viewModel.filters.Countries[index].checked = false;
                    }
                }
                //
                viewModel.Header = _header;
                viewModel.showMore = results[0].ShowMore;
                viewModel.showMoreText = _showMoreText;
                viewModel.ShowJobList = viewModel.jobs.length > 0 ? true : false;
                viewModel.ShowNoJob = !viewModel.ShowJobList;
                viewModel.NoJobDes = _noJobDes;
                viewModel.NoJobLink = _NoJobLink;
                viewModel.NoJobLinkDes = _noJobLinkDes
                render(viewModel);
            });
        });

    }
    js.jobs = (function () {
        function initialize(domElm, templateUrl, filterTemplateUrl, jsonUrl, showFilters, showAllFilterOption,
            brandTheme, showAllText, layoutAlgorithm, showMoreText, easyCruitUrl, maxFetchCount,
            detailFeedUrl, header, showType, noJobDes, noJobLink, allCountries, noJobLinkDes) {

            _domElm = domElm;
            _showType = showType;
            _showMoreText = showMoreText;
            _fetchItemCount = maxFetchCount;
            _detailFeedUrl = detailFeedUrl;
            _header = header;
            _noJobDes = noJobDes;
            _NoJobLink = noJobLink;
            _allCountries = allCountries;
            _noJobLinkDes = noJobLinkDes;

            utils.cookie.rem('jobTypeFilter');
            utils.cookie.rem('jobCountriesFilter');
            var clearCacheValue = isClearCache("clearcache");
            if (clearCacheValue) {
                jsonUrl = jsonUrl + clearCacheValue;
            }
            _domElm.addEventListener('click', function (e) {
                if (e.target.classList.contains('js-teaser-deck__show-more-button')) {
                    e.preventDefault();
                    pageIndex += 1;
                    var postdata = {
                        DataFeedUrl: easyCruitUrl,
                        DetailFeedUrl:_detailFeedUrl,
                        MaxFetchItemCount: _fetchItemCount,
                        PageIndex: pageIndex,
                        SelectedJobTypes: selectedJobTypes,
                        SelectedCountries: selectedCountries,
                        JsonUrl: jsonUrl,
                        AllCountries: _allCountries,
                    };
                    if (!postdata.selectedCountries && utils.cookie.get("jobCountriesFilter")) {
                        var array = utils.cookie.get("jobCountriesFilter").split(',');
                        if ((array.length == 1 && !array[0]) || (array.length == 1 && array[0] == "null")) {
                            postdata.selectedCountries = null;
                        } else {
                            postdata.selectedCountries = utils.cookie.get("jobCountriesFilter").split(',');
                        }
                    }

                    if (!postdata.SelectedJobTypes && utils.cookie.get("jobTypeFilter")) {
                        var array = utils.cookie.get("jobTypeFilter").split(',');
                        if ((array.length == 1 && !array[0])|| (array.length == 1 && array[0] == "null")) {
                            postdata.SelectedJobTypes = null;
                        } else {
                            postdata.SelectedJobTypes = utils.cookie.get("jobTypeFilter").split(',');
                        }
                    }


                    fetchData(postdata, false);
                    return;
                }
                if (e.target.classList.contains('filter-categories')) {
                    selectedJobTypes = utils.getSelectedOptionValues('filter-categories');
                    utils.cookie.set('jobTypeFilter', '', true, true);
                    utils.cookie.set('jobTypeFilter', selectedJobTypes, true, true);
                    pageIndex = 1;

                    var postdata = {
                        DataFeedUrl: easyCruitUrl,
                        DetailFeedUrl: _detailFeedUrl,
                        MaxFetchItemCount: _fetchItemCount,
                        PageIndex: pageIndex,
                        SelectedJobTypes: selectedJobTypes,
                        SelectedCountries: selectedCountries,
                        JsonUrl: jsonUrl,
                        AllCountries: _allCountries,
                    };
                    if (!postdata.SelectedCountries && utils.cookie.get("jobCountriesFilter")) {
                        var array = utils.cookie.get("jobCountriesFilter").split(',');
                        if ((array.length == 1 && !array[0])||(array.length == 1 && array[0] == "null")) {
                            postdata.SelectedCountries = null;
                        } else {
                            postdata.SelectedCountries = utils.cookie.get("jobCountriesFilter").split(',');
                        }
                    }
                    fetchData(postdata,true);
                }
                if (e.target.classList.contains("filter-countries")) {
                    selectedCountries = utils.getSelectedOptionValues('filter-countries');

                    utils.cookie.set('jobCountriesFilter', '', true, true);
                    utils.cookie.set('jobCountriesFilter', selectedCountries, true, true);

                    pageIndex = 1;
                    var postdata = {
                        DataFeedUrl: easyCruitUrl,
                        DetailFeedUrl: _detailFeedUrl,
                        MaxFetchItemCount: _fetchItemCount,
                        PageIndex: pageIndex,
                        SelectedJobTypes: selectedJobTypes,
                        SelectedCountries: selectedCountries,
                        JsonUrl: jsonUrl,
                        AllCountries: _allCountries,
                    };
                    if (!postdata.SelectedJobTypes && utils.cookie.get("jobTypeFilter")) {
                        var array = utils.cookie.get("jobTypeFilter").split(',');
                        if ((array.length == 1 && !array[0])|| (array.length == 1 && array[0] == "null")) {
                            postdata.SelectedJobTypes = null;
                        } else {
                            postdata.SelectedJobTypes = utils.cookie.get("jobTypeFilter").split(',');
                        }
                    }
                    fetchData(postdata,true);
                }
                if (e.target.classList.contains('js-filters__drowpdown-activator')) {
                    e.preventDefault();
                    var elm = document.querySelector(".js-filters__list");
                    if (elm.classList.contains("active")) {
                        _renderFiltersExpanded = false;
                        elm.classList.remove("active");
                        elm.setAttribute('style',  '');
                        e.target.parentElement.classList.remove('filters--active');
                    } else {
                        elm.classList.add("active");
                        _renderFiltersExpanded = true;
                        elm.setAttribute('style', 'height:' + (elm.clientHeight + 1) + 'px');
                        e.target.parentElement.classList.add('filters--active');
                    }
                }
            }, false);

            
          
            var templatePromise = fetch(templateUrl);
            var filterTemplatePromise = fetch(filterTemplateUrl);

            var postdata = {
                DataFeedUrl:easyCruitUrl,
                DetailFeedUrl: _detailFeedUrl, 
                MaxFetchItemCount: _fetchItemCount,
                PageIndex: pageIndex,
                SelectedJobTypes:selectedJobTypes,
                SelectedCountries: selectedCountries,
                JsonUrl: jsonUrl,
                AllCountries: _allCountries,
            };
            if (!postdata.SelectedCountries && utils.cookie.get("jobCountriesFilter")) {
                var array = utils.cookie.get("jobCountriesFilter").split(',');
                console.log("array:", array);
                if ((array.length == 1 && !array[0]) || (array.length == 1 && array[0] == "null")) {
                    postdata.SelectedCountries = null;
                } else {
                    postdata.SelectedCountries = utils.cookie.get("jobCountriesFilter").split(',');
                }
            }

            if (!postdata.SelectedJobTypes && utils.cookie.get("jobTypeFilter")) {
                var array = utils.cookie.get("jobTypeFilter").split(',');
                if ((array.length == 1 && !array[0]) || (array.length == 1 && array[0] == "null")) {
                    postdata.SelectedJobTypes = null;
                } else {
                    postdata.SelectedJobTypes = utils.cookie.get("jobTypeFilter").split(',');
                }
            }

            Promise.all([templatePromise, filterTemplatePromise]).then(function (results) {
                Promise.all([
                    results[0].text(),
                    results[1].text(),
                ]).then(function (results) {
                    _template = results[0];
                    _filterTemplate = results[1];
                }).then(function () {
                    fetchData(postdata,false);
                });
            });
        }
        return {
            initialize: initialize
        };
    })();
})();